"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatters = exports.formatMultipleLinesString = exports.formatLanguagePreference = exports.formatDatePreference = exports.formatAddress = void 0;
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var formatAddress = function (_a) {
    var _b = _a.street1, street1 = _b === void 0 ? '' : _b, _c = _a.street2, street2 = _c === void 0 ? '' : _c, _d = _a.city, city = _d === void 0 ? '' : _d, _e = _a.state, state = _e === void 0 ? '' : _e, zipCode = _a.zipCode, _f = _a.country, country = _f === void 0 ? '' : _f;
    var st1 = street1 ? "".concat(street1, "\n") : '';
    var st2 = street2 ? "".concat(street2, "\n") : '';
    var fcity = city ? "".concat(city, ",") : '';
    var fstate = "".concat(state, " ").concat(zipCode, "\n");
    var fcountry = country ? "".concat(country) : '';
    return "".concat(st1, " ").concat(st2, " ").concat(fcity, " ").concat(fstate, " ").concat(fcountry);
};
exports.formatAddress = formatAddress;
var formatDatePreference = function (format) { return react_common_lib_1.datePreferences[format]; };
exports.formatDatePreference = formatDatePreference;
var formatLanguagePreference = function (languageKey) {
    return react_common_lib_1.languagePreferences[languageKey];
};
exports.formatLanguagePreference = formatLanguagePreference;
var formatMultipleLinesString = function (data) {
    return data.length ? data.reduce(function (prev, curr) { return "".concat(prev, "\n ").concat(curr); }) : '';
};
exports.formatMultipleLinesString = formatMultipleLinesString;
exports.formatters = {
    address: exports.formatAddress,
    datePreference: exports.formatDatePreference,
    languagePreference: exports.formatLanguagePreference,
    multiLineString: exports.formatMultipleLinesString,
};
